/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinancingPeriodDays
 */
export interface FinancingPeriodDays {
}

/**
 * Check if a given object implements the FinancingPeriodDays interface.
 */
export function instanceOfFinancingPeriodDays(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FinancingPeriodDaysFromJSON(json: any): FinancingPeriodDays {
    return FinancingPeriodDaysFromJSONTyped(json, false);
}

export function FinancingPeriodDaysFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancingPeriodDays {
    return json;
}

export function FinancingPeriodDaysToJSON(value?: FinancingPeriodDays | null): any {
    return value;
}

